export default __webpack_public_path__ + "static/company-petco-6cec6001c8bd210873fc465f40a3beee.png";